import React, { Component } from 'react'
import Grid from '@material-ui/Core/Grid'
import Divider from '@material-ui/Core/Divider';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Dialog, DialogTitle, Button, ButtonGroup, DialogContentText } from '@material-ui/core'
import EmailDialog from '../../components/EmailDialog'
import PrintIcon from '@material-ui/icons/Print'; 
import PDF from '../PDF';

import CloseIcon from '@material-ui/icons/Close';

import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import * as html2pdf from 'html2pdf.js'

function ConfirmDialog(props) {
    const { onClose, selectedValue, open, saving } = props;
    const handleClose = () => {
        onClose(false);
    };
  
    const handleAcceptClick = (value) => {
        onClose(value);
    };

    return (
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
        <div style={{display:'flex', flexDirection:'row-reverse'}}>
            <Button onClick={()=> handleAcceptClick(false)}><CloseIcon /></Button>
        </div>
        <p id="simple-dialog-title" style={{margin:'0px 30px 20px 30px'}}>{props.downloadPopup.Message}</p>
        <Grid container direction="row"
                justifyContent="center"
                alignItems="stretch" 
                style={{justifyContent:'center', marginBottom:'15px'}}>
                    <Button variant="contained" color="primary" onClick={()=> handleAcceptClick(true)}>{props.downloadPopup.Accept}<img src="loading.gif" width='20px' style={{marginLeft: '4px', display: saving ? 'block' : 'none'}}/></Button >
                    <Button variant="outlined" onClick={()=> handleAcceptClick(false)}>{props.downloadPopup.Decline}</Button>

        </Grid>       
      </Dialog>
    );
  }

class HeaderButtons extends Component {
    constructor(props){
        super(props)
        this.state = {
            open: false,
            saveFormat: '',
            selectedDialogValue: false,
            saving: false
        }

        this.pdfDeprettifier = this.pdfDeprettifier.bind(this);
        this.pdfPrettifier = this.pdfPrettifier.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.downloadPDF = this.downloadPDF.bind(this);
        this.setOpen = this.setOpen.bind(this);
        this.setSaveFormat = this.setSaveFormat.bind(this);
        this.setSelectedDialogValue = this.setSelectedDialogValue.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.generateFileName = this.generateFileName.bind(this);
    }

    setOpen(value){
        this.setState({
            open: value
        })
    }

    setSaveFormat(value){
        this.setState({
            saveFormat: value
        })
    }

    setSelectedDialogValue(value){
        this.setState({
            selectedDialogValue: value
        })
    }

    handlePrint(){
        
        window.print() 
    }

    pdfPrettifier(){
        this.props.expandAccordions(true)
        document.getElementsByClassName('results-button').forEach(function(child){
            child.style.boxShadow = "none";
        })

        document.getElementsByClassName('MuiAccordion-root').forEach(function(child){
            child.style.boxShadow = "none";
        })

        let input = document.getElementById('resultscontent')

        return input;

    }

    buffer(ms){
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    pdfDeprettifier(){
        document.getElementsByClassName('results-button').forEach(function(child){
            child.style.boxShadow = "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)";
        })

        document.getElementsByClassName('MuiAccordion-root').forEach(function(child){
            child.style.boxShadow = "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)";
        })
   
        this.props.expandAccordions(false)
    }
    generateFileName(){
        let assessmentName = this.props.name.length ? this.props.name : ""
        let assessmentNameAsFileNameComponent = assessmentName.replaceAll(" ","-")
        let todayDate = new Date().toISOString().slice(0, 10);
        let fileName = assessmentNameAsFileNameComponent + '-Wellactivate-'+ todayDate + '.pdf'       
        return fileName
    }
    

    handleDownload(){
            const input = this.pdfPrettifier();
            var HTML_Width = document.getElementById('resultscontent').offsetWidth;
		    var HTML_Height = document.getElementById('resultscontent').offsetHeight;
		    var top_left_margin = 15;
		    var PDF_Width = HTML_Width+(top_left_margin*2);
		    var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
		    var canvas_image_width = HTML_Width;
            var canvas_image_height = HTML_Height;
            var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;

            let height = 0;
            let doc= []
            input.children.forEach(function(child){
                if(child.id=="#buttonGroup"){
                    //put the other elements into a 
                    //render the text as a button I guess???
                    
                } else {

                }
            })

            html2canvas(input,{allowTaint:true, scale: 2})
            .then((canvas) => {
                
                canvas.getContext('2d');
			
			
			
			var imgData = canvas.toDataURL("image/jpeg", 1.0);
            var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
            pdf.html(input, {x: 10, y:10})
		    pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);
			
			
			for (var i = 1; i <= totalPDFPages; i++) { 
				pdf.addPage(""+PDF_Width, ""+PDF_Height);
				pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
			}
			
            pdf.save(this.generateFileName());
            
          })

          this.pdfDeprettifier();
        ;
        
    }

    downloadPDF(){
        let logoCanvas
        let assessmentName = this.props.name.length ? this.props.name : ""

        let logoHeight =  document.getElementById('logo-image').height*0.8/96
        let logoWidth = document.getElementById('logo-image').width*0.8/96
        html2canvas(document.getElementById('logo-image'), {scale:2, allowTaint:true})
            .then((canvas) => {
                
                canvas.getContext('2d');
                canvas.toDataURL('image/jpeg', 1.0);
                logoCanvas = canvas
            })

        const element = this.pdfPrettifier();
        return new Promise((resolve,reject) => {
        setTimeout(() => { const opt = {
            margin: 1,
            filename: this.generateFileName(),
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };
        html2pdf().from(element).set(opt).toPdf().get('pdf').then(function(pdf){
            var totalPages = pdf.internal.getNumberOfPages(); 

            for (var i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);
              //divided by 2 to go center
              pdf.text(String(i), pdf.internal.pageSize.getWidth()-1, pdf.internal.pageSize.getHeight()-.6);
              pdf.text(assessmentName, pdf.internal.pageSize.getWidth()-2, .6)
              pdf.text(assessmentName, 1, pdf.internal.pageSize.getHeight()-.6)
              pdf.addImage(logoCanvas, 'JPEG', 0.1,0.1,logoWidth, logoHeight)
            }
              //
            
            }).save();
        }, 800)
        setTimeout(() => {this.pdfDeprettifier(); resolve()}, 1000);
        })
    }

    handleClickOpen(format){
        this.setOpen(true)
        this.setSaveFormat(format)
    }

    handleClose(value){
        
        this.setSelectedDialogValue(value);
        
        if(value){
            if(this.state.saveFormat=="download"){
                this.setState({
                    saving: true
                })
                this.downloadPDF().then(() => {this.setOpen(false); this.setState({saving:false})})
                
            }
            if(this.state.saveFormat == "print"){
                this.setOpen(false)
                setTimeout(()=> {this.handlePrint()}, 400)
                
            }
        } else {
            this.setOpen(false)
        }
    }

    render() { 
        return(
            <div id="headerButtons">
                <Grid container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                    noWrap
                    spacing={2}>
                    <Grid item>
                         <IconButton onClick={() => this.handleClickOpen('print')}>
                             <PrintIcon style={{fill: "#9f9f9f"}}/>
                         </IconButton>
                    </Grid>
                    <Grid item>
                        <IconButton onClick={() => this.handleClickOpen('download')}>
                            <GetAppIcon style={{fill: "#9f9f9f"}}/>
                        </IconButton>
                    </Grid>
                </Grid>
                <ConfirmDialog downloadPopup={this.props.downloadPopup} selectedValue={this.state.selectedValue} open={this.state.open} onClose={this.handleClose} saving={this.state.saving}></ConfirmDialog>
        </div> 
        )
    }
}



/*<Grid item>
                        <IconButton onClick={this.handleDownload}>
                            <GetAppIcon style={{fill: "#9f9f9f"}}/>
                        </IconButton>
                    </Grid>*/
export default HeaderButtons